var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpadeVectors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 879,
    height: 1006,
    viewBox: "0 0 879 1006",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.42 246.619C657.4 246.929 656.25 247.159 655 247.309L571.72 642.849L574.71 644.219L658.42 246.629V246.619Z",
    fill: "url(#paint0_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M829.58 586.469L649.41 418.439C649.14 419.249 648.84 420.049 648.48 420.829L828.35 588.589C828.6 587.799 829.01 587.079 829.57 586.469H829.58Z",
    fill: "url(#paint1_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3 453.309C250.46 454.049 249.61 454.769 248.74 455.459C247.92 452.179 247.05 448.709 246.11 445.039C247.76 447.319 249.57 450.079 251.3 453.309Z",
    fill: "#51C8EE",
    stroke: "#8ED6ED",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.42 276.811C183.96 276.921 183.5 277.021 183.03 277.121L307.43 564.551C308.08 564.871 308.76 565.271 309.47 565.751L184.42 276.811Z",
    fill: "url(#paint2_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.59 649.64L69.36 410.01C68.9 410.93 68.4 411.81 67.85 412.68L488.94 651.66C489.62 650.78 490.51 650.06 491.59 649.64Z",
    fill: "url(#paint3_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.09 669.91L224.03 300.38C222.86 299.71 221.61 298.85 220.28 297.83L386.89 670.83C387.61 670.5 388.34 670.19 389.09 669.91Z",
    fill: "url(#paint4_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M319.17 977.48C319.51 978.68 319.78 980.05 319.99 981.55L581.49 382.43L579.59 380.83L319.17 977.49V977.48Z",
    fill: "url(#paint5_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.04 216.161C632.01 215.011 632.08 213.751 632.25 212.391L252.51 630.411L253.86 632.461L632.04 216.171V216.161Z",
    fill: "url(#paint6_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.5 24.6309C441.93 25.1609 441.21 25.5709 440.37 25.8009L613.75 606.181C614.79 606.881 615.88 607.741 617 608.761L442.5 24.6409V24.6309Z",
    fill: "url(#paint7_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M444.68 22.7207C443.96 23.0707 443.23 23.3807 442.49 23.6807L784.37 640.731C785.59 641.291 786.9 642.021 788.3 642.911L444.69 22.7307L444.68 22.7207Z",
    fill: "url(#paint8_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.02 976.52C560.74 976.02 561.51 975.56 562.34 975.13L338.28 842.91L336.88 844.85L560.02 976.52Z",
    fill: "url(#paint9_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M340.87 841.749C340.76 842.979 340.53 844.329 340.19 845.789L793.36 393.959L792.17 391.779L340.87 841.749Z",
    fill: "url(#paint10_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M517.25 713.98L433.51 981.62C434.18 982.32 434.83 983.11 435.44 983.97L518.84 717.451C518.22 716.341 517.69 715.18 517.26 713.99L517.25 713.98Z",
    fill: "url(#paint11_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.87 980.239L529.39 688.259L527.39 686.939L385.66 979.339C386.52 979.489 387.26 979.799 387.87 980.239Z",
    fill: "url(#paint12_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M342.81 981.531L528.9 808.581C528.62 807.751 528.4 806.871 528.23 805.961L341.38 979.621C342 980.141 342.49 980.801 342.82 981.531H342.81Z",
    fill: "url(#paint13_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.06 696.72L550.23 137.54C549.73 135.29 549.53 132.81 549.59 130.15L195.27 695.96C196.87 696.2 198.47 696.45 200.06 696.72Z",
    fill: "url(#paint14_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M444.08 23.17C443.37 22.81 442.67 22.42 441.99 22L47.61 588.66C47.67 589.96 47.62 591.42 47.48 593.02L444.08 23.17Z",
    fill: "url(#paint15_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83 352.279C111.51 352.559 110.01 352.759 108.35 352.879L781.68 654.819L783.39 652.979L112.83 352.279Z",
    fill: "url(#paint16_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.28 668.691L688.14 278.431L685.99 277.131L598.01 667.901C598.78 668.121 599.53 668.381 600.27 668.691H600.28Z",
    fill: "url(#paint17_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.29 684.69L856.28 478.58C855.86 477.88 855.47 477.16 855.11 476.42L633.78 682.85C634.43 683.34 634.93 683.98 635.29 684.69Z",
    fill: "url(#paint18_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M657.79 694.49L816.5 419.55C815.85 419.08 815.23 418.56 814.64 418.01L655.38 693.9C656.18 694.05 656.99 694.24 657.79 694.48V694.49Z",
    fill: "url(#paint19_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M398.71 87.5098C398.06 87.9098 397.39 88.2898 396.69 88.6398L852.95 539.42L855.38 538.69L398.72 87.5098H398.71Z",
    fill: "url(#paint20_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.5 603.5L761.18 349.89C760.45 349.58 759.73 349.23 759.03 348.85L658.12 603.04C658.95 603.04 659.77 603.2 660.5 603.5Z",
    fill: "url(#paint21_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.4 884.789L479.15 981.199L480.49 984.009L531.31 890.229C531.31 888.419 531.34 886.609 531.39 884.789H531.4Z",
    fill: "url(#paint22_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.04 684.669L617.04 198.399C616.41 197.919 615.8 197.409 615.21 196.869L262.75 685.169C263.83 684.929 264.93 684.749 266.04 684.669Z",
    fill: "url(#paint23_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.14 686.42L756.58 353.88C755.88 353.47 755.22 353.03 754.6 352.57L523.22 685.03C524 685.35 524.64 685.84 525.14 686.43V686.42Z",
    fill: "url(#paint24_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.44 24.9395L124.42 666.869C124.75 668.229 124.98 669.759 125.14 671.449L447.21 27.3994C446.38 26.7694 445.79 25.8995 445.43 24.9395H445.44Z",
    fill: "url(#paint25_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M439.1 30.2003C439.1 30.2003 439.1 30.1803 439.11 30.1703C438.99 30.1403 438.87 30.1103 438.75 30.0703C437.98 31.5603 437.07 33.3303 436.02 35.3903L461.04 637.78C462.18 638.11 463.3 638.5 464.39 638.97L439.11 30.2003H439.1Z",
    fill: "url(#paint26_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M415.4 581.73C415.18 583.87 414.84 585.99 414.35 588.06L538.94 970.781C539.41 969.151 539.93 967.58 540.52 966.08L415.4 581.73Z",
    fill: "url(#paint27_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.16 89.8092C497.44 89.6492 496.82 89.3392 496.29 88.9492L456.57 313.629C456.55 318.939 456.49 324.199 456.41 329.389L498.47 91.4892V89.8692C498.36 89.8492 498.26 89.8392 498.17 89.8192L498.16 89.8092Z",
    fill: "url(#paint28_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M203.1 690.091L22.9301 522.061C22.6601 522.871 22.36 523.671 22 524.451L201.87 692.211C202.12 691.421 202.53 690.701 203.09 690.091H203.1Z",
    fill: "url(#paint29_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M180.95 685.94L245.87 393.98C244.97 394.56 244.09 395.04 243.23 395.43L178.73 685.48C179.48 685.6 180.22 685.75 180.94 685.94H180.95Z",
    fill: "url(#paint30_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M126.53 340.73L110.49 666.75C111.29 666.86 112.08 667.01 112.85 667.2L128.98 339.34C128.19 339.85 127.37 340.32 126.53 340.73Z",
    fill: "url(#paint31_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M27.5 461.08L27.64 458.85L530.55 687.84C530.18 688.43 529.84 689.04 529.54 689.67",
    fill: "url(#paint32_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M500.52 650.7L157.71 310.75C157.45 311.07 157.18 311.39 156.9 311.69C156.64 311.97 156.37 312.25 156.11 312.51L497.14 650.7H500.52Z",
    fill: "url(#paint33_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.67 82.9805C394.79 84.3305 393.77 85.5905 392.62 86.7305L433.21 979.25L436.47 980.141L395.67 82.9805Z",
    fill: "url(#paint34_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.27 305.89L314.02 172.67C313.46 173.34 312.86 173.98 312.22 174.59L719.13 308.35C719.13 307.52 719.17 306.69 719.27 305.88V305.89Z",
    fill: "url(#paint35_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M92.71 664.719L746.36 342.769L745.86 339.869L90.75 662.539C91.45 663.219 92.1 663.949 92.7 664.719H92.71Z",
    fill: "url(#paint36_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.88 716.901L486.93 432.32C486.12 432.25 485.3 432.13 484.49 431.98L517.83 719.98C518.48 718.93 519.16 717.901 519.87 716.901H519.88Z",
    fill: "url(#paint37_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.1 581.15L277.93 198.5C277.19 198.8 276.44 199.06 275.68 199.28L439.93 582.12C440.64 581.78 441.36 581.46 442.11 581.16L442.1 581.15Z",
    fill: "url(#paint38_linear_3572_5)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M387.64 546.489L349.35 131.869C348.56 131.929 347.76 131.939 346.96 131.919L385.27 546.739C386.05 546.629 386.84 546.549 387.64 546.499V546.489Z",
    fill: "url(#paint39_linear_3572_5)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M694.28 631.889C696.765 631.889 698.78 629.874 698.78 627.389C698.78 624.903 696.765 622.889 694.28 622.889C691.795 622.889 689.78 624.903 689.78 627.389C689.78 629.874 691.795 631.889 694.28 631.889Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M783.06 658.928C785.545 658.928 787.56 656.913 787.56 654.428C787.56 651.942 785.545 649.928 783.06 649.928C780.575 649.928 778.56 651.942 778.56 654.428C778.56 656.913 780.575 658.928 783.06 658.928Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.13 645.619C788.615 645.619 790.63 643.604 790.63 641.119C790.63 638.634 788.615 636.619 786.13 636.619C783.645 636.619 781.63 638.634 781.63 641.119C781.63 643.604 783.645 645.619 786.13 645.619Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750.3 580.658C752.785 580.658 754.8 578.643 754.8 576.158C754.8 573.673 752.785 571.658 750.3 571.658C747.815 571.658 745.8 573.673 745.8 576.158C745.8 578.643 747.815 580.658 750.3 580.658Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M737.81 558.26C740.295 558.26 742.31 556.245 742.31 553.76C742.31 551.274 740.295 549.26 737.81 549.26C735.325 549.26 733.31 551.274 733.31 553.76C733.31 556.245 735.325 558.26 737.81 558.26Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855.18 544.289C857.665 544.289 859.68 542.274 859.68 539.789C859.68 537.304 857.665 535.289 855.18 535.289C852.695 535.289 850.68 537.304 850.68 539.789C850.68 542.274 852.695 544.289 855.18 544.289Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M856.45 481.508C858.935 481.508 860.95 479.493 860.95 477.008C860.95 474.523 858.935 472.508 856.45 472.508C853.965 472.508 851.95 474.523 851.95 477.008C851.95 479.493 853.965 481.508 856.45 481.508Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M815.6 422.758C818.085 422.758 820.1 420.743 820.1 418.258C820.1 415.773 818.085 413.758 815.6 413.758C813.115 413.758 811.1 415.773 811.1 418.258C811.1 420.743 813.115 422.758 815.6 422.758Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M823.02 512.879C825.505 512.879 827.52 510.864 827.52 508.379C827.52 505.894 825.505 503.879 823.02 503.879C820.535 503.879 818.52 505.894 818.52 508.379C818.52 510.864 820.535 512.879 823.02 512.879Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M784.88 475.258C787.365 475.258 789.38 473.243 789.38 470.758C789.38 468.273 787.365 466.258 784.88 466.258C782.395 466.258 780.38 468.273 780.38 470.758C780.38 473.243 782.395 475.258 784.88 475.258Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.39 488.959C705.875 488.959 707.89 486.944 707.89 484.459C707.89 481.974 705.875 479.959 703.39 479.959C700.905 479.959 698.89 481.974 698.89 484.459C698.89 486.944 700.905 488.959 703.39 488.959Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.85 398.539C793.335 398.539 795.35 396.524 795.35 394.039C795.35 391.554 793.335 389.539 790.85 389.539C788.365 389.539 786.35 391.554 786.35 394.039C786.35 396.524 788.365 398.539 790.85 398.539Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719.1 410.209C721.585 410.209 723.6 408.194 723.6 405.709C723.6 403.224 721.585 401.209 719.1 401.209C716.615 401.209 714.6 403.224 714.6 405.709C714.6 408.194 716.615 410.209 719.1 410.209Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M757.5 356.109C759.985 356.109 762 354.095 762 351.609C762 349.124 759.985 347.109 757.5 347.109C755.015 347.109 753 349.124 753 351.609C753 354.095 755.015 356.109 757.5 356.109Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M746.46 345.229C748.945 345.229 750.96 343.214 750.96 340.729C750.96 338.243 748.945 336.229 746.46 336.229C743.975 336.229 741.96 338.243 741.96 340.729C741.96 343.214 743.975 345.229 746.46 345.229Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719.11 311.379C721.595 311.379 723.61 309.364 723.61 306.879C723.61 304.394 721.595 302.379 719.11 302.379C716.625 302.379 714.61 304.394 714.61 306.879C714.61 309.364 716.625 311.379 719.11 311.379Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.47 282.168C689.955 282.168 691.97 280.153 691.97 277.668C691.97 275.183 689.955 273.168 687.47 273.168C684.985 273.168 682.97 275.183 682.97 277.668C682.97 280.153 684.985 282.168 687.47 282.168Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.67 89.6797C397.155 89.6797 399.17 87.665 399.17 85.1797C399.17 82.6944 397.155 80.6797 394.67 80.6797C392.185 80.6797 390.17 82.6944 390.17 85.1797C390.17 87.665 392.185 89.6797 394.67 89.6797Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.45 27.7188C445.935 27.7188 447.95 25.704 447.95 23.2188C447.95 20.7335 445.935 18.7188 443.45 18.7188C440.965 18.7188 438.95 20.7335 438.95 23.2188C438.95 25.704 440.965 27.7188 443.45 27.7188Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.26 92.4082C500.745 92.4082 502.76 90.3935 502.76 87.9082C502.76 85.4229 500.745 83.4082 498.26 83.4082C495.775 83.4082 493.76 85.4229 493.76 87.9082C493.76 90.3935 495.775 92.4082 498.26 92.4082Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386 986.379C388.485 986.379 390.5 984.364 390.5 981.879C390.5 979.394 388.485 977.379 386 977.379C383.515 977.379 381.5 979.394 381.5 981.879C381.5 984.364 383.515 986.379 386 986.379Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.5 986.549C436.985 986.549 439 984.534 439 982.049C439 979.564 436.985 977.549 434.5 977.549C432.015 977.549 430 979.564 430 982.049C430 984.534 432.015 986.549 434.5 986.549Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.83 974.129C542.315 974.129 544.33 972.114 544.33 969.629C544.33 967.144 542.315 965.129 539.83 965.129C537.345 965.129 535.33 967.144 535.33 969.629C535.33 972.114 537.345 974.129 539.83 974.129Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.71 981.299C564.195 981.299 566.21 979.284 566.21 976.799C566.21 974.314 564.195 972.299 561.71 972.299C559.225 972.299 557.21 974.314 557.21 976.799C557.21 979.284 559.225 981.299 561.71 981.299Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.23 987.439C482.715 987.439 484.73 985.425 484.73 982.939C484.73 980.454 482.715 978.439 480.23 978.439C477.745 978.439 475.73 980.454 475.73 982.939C475.73 985.425 477.745 987.439 480.23 987.439Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.54 891.369C534.025 891.369 536.04 889.354 536.04 886.869C536.04 884.384 534.025 882.369 531.54 882.369C529.055 882.369 527.04 884.384 527.04 886.869C527.04 889.354 529.055 891.369 531.54 891.369Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.34 982.979C322.825 982.979 324.84 980.964 324.84 978.479C324.84 975.993 322.825 973.979 320.34 973.979C317.855 973.979 315.84 975.993 315.84 978.479C315.84 980.964 317.855 982.979 320.34 982.979Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.58 984.398C345.065 984.398 347.08 982.384 347.08 979.898C347.08 977.413 345.065 975.398 342.58 975.398C340.095 975.398 338.08 977.413 338.08 979.898C338.08 982.384 340.095 984.398 342.58 984.398Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.61 918.309C459.095 918.309 461.11 916.294 461.11 913.809C461.11 911.323 459.095 909.309 456.61 909.309C454.125 909.309 452.11 911.323 452.11 913.809C452.11 916.294 454.125 918.309 456.61 918.309Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.71 901.75C431.195 901.75 433.21 899.735 433.21 897.25C433.21 894.765 431.195 892.75 428.71 892.75C426.225 892.75 424.21 894.765 424.21 897.25C424.21 899.735 426.225 901.75 428.71 901.75Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.44 811.09C531.925 811.09 533.94 809.075 533.94 806.59C533.94 804.105 531.925 802.09 529.44 802.09C526.955 802.09 524.94 804.105 524.94 806.59C524.94 809.075 526.955 811.09 529.44 811.09Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.58 815.02C491.065 815.02 493.08 813.005 493.08 810.52C493.08 808.034 491.065 806.02 488.58 806.02C486.095 806.02 484.08 808.034 484.08 810.52C484.08 813.005 486.095 815.02 488.58 815.02Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.47 790.59C482.955 790.59 484.97 788.575 484.97 786.09C484.97 783.605 482.955 781.59 480.47 781.59C477.985 781.59 475.97 783.605 475.97 786.09C475.97 788.575 477.985 790.59 480.47 790.59Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.09 849.1C341.575 849.1 343.59 847.085 343.59 844.6C343.59 842.114 341.575 840.1 339.09 840.1C336.605 840.1 334.59 842.114 334.59 844.6C334.59 847.085 336.605 849.1 339.09 849.1Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.98 780.58C410.465 780.58 412.48 778.565 412.48 776.08C412.48 773.595 410.465 771.58 407.98 771.58C405.495 771.58 403.48 773.595 403.48 776.08C403.48 778.565 405.495 780.58 407.98 780.58Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.95 744.27C426.435 744.27 428.45 742.255 428.45 739.77C428.45 737.284 426.435 735.27 423.95 735.27C421.465 735.27 419.45 737.284 419.45 739.77C419.45 742.255 421.465 744.27 423.95 744.27Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.99 728.709C463.475 728.709 465.49 726.694 465.49 724.209C465.49 721.724 463.475 719.709 460.99 719.709C458.505 719.709 456.49 721.724 456.49 724.209C456.49 726.694 458.505 728.709 460.99 728.709Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.61 715.77C520.095 715.77 522.11 713.755 522.11 711.27C522.11 708.784 520.095 706.77 517.61 706.77C515.125 706.77 513.11 708.784 513.11 711.27C513.11 713.755 515.125 715.77 517.61 715.77Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.46 698.959C200.945 698.959 202.96 696.944 202.96 694.459C202.96 691.974 200.945 689.959 198.46 689.959C195.975 689.959 193.96 691.974 193.96 694.459C193.96 696.944 195.975 698.959 198.46 698.959Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.78 689.619C182.265 689.619 184.28 687.604 184.28 685.119C184.28 682.634 182.265 680.619 179.78 680.619C177.295 680.619 175.28 682.634 175.28 685.119C175.28 687.604 177.295 689.619 179.78 689.619Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.2 673.01C127.685 673.01 129.7 670.995 129.7 668.51C129.7 666.024 127.685 664.01 125.2 664.01C122.715 664.01 120.7 666.024 120.7 668.51C120.7 670.995 122.715 673.01 125.2 673.01Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.59 672.689C114.075 672.689 116.09 670.675 116.09 668.189C116.09 665.704 114.075 663.689 111.59 663.689C109.105 663.689 107.09 665.704 107.09 668.189C107.09 670.675 109.105 672.689 111.59 672.689Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.97 667.469C94.4553 667.469 96.47 665.454 96.47 662.969C96.47 660.483 94.4553 658.469 91.97 658.469C89.4847 658.469 87.47 660.483 87.47 662.969C87.47 665.454 89.4847 667.469 91.97 667.469Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.73 640.93C144.215 640.93 146.23 638.915 146.23 636.43C146.23 633.944 144.215 631.93 141.73 631.93C139.245 631.93 137.23 633.944 137.23 636.43C137.23 638.915 139.245 640.93 141.73 640.93Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.22 612.77C116.705 612.77 118.72 610.755 118.72 608.27C118.72 605.784 116.705 603.77 114.22 603.77C111.735 603.77 109.72 605.784 109.72 608.27C109.72 610.755 111.735 612.77 114.22 612.77Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.34 615.459C198.825 615.459 200.84 613.444 200.84 610.959C200.84 608.474 198.825 606.459 196.34 606.459C193.855 606.459 191.84 608.474 191.84 610.959C191.84 613.444 193.855 615.459 196.34 615.459Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.22 548.969C213.705 548.969 215.72 546.954 215.72 544.469C215.72 541.983 213.705 539.969 211.22 539.969C208.735 539.969 206.72 541.983 206.72 544.469C206.72 546.954 208.735 548.969 211.22 548.969Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.37 539.709C193.855 539.709 195.87 537.694 195.87 535.209C195.87 532.724 193.855 530.709 191.37 530.709C188.885 530.709 186.87 532.724 186.87 535.209C186.87 537.694 188.885 539.709 191.37 539.709Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.97 502C224.455 502 226.47 499.985 226.47 497.5C226.47 495.015 224.455 493 221.97 493C219.485 493 217.47 495.015 217.47 497.5C217.47 499.985 219.485 502 221.97 502Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.54 496.869C215.025 496.869 217.04 494.854 217.04 492.369C217.04 489.884 215.025 487.869 212.54 487.869C210.055 487.869 208.04 489.884 208.04 492.369C208.04 494.854 210.055 496.869 212.54 496.869Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 506.77C122.485 506.77 124.5 504.755 124.5 502.27C124.5 499.784 122.485 497.77 120 497.77C117.515 497.77 115.5 499.784 115.5 502.27C115.5 504.755 117.515 506.77 120 506.77Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9 594.609C50.3853 594.609 52.4 592.595 52.4 590.109C52.4 587.624 50.3853 585.609 47.9 585.609C45.4147 585.609 43.4 587.624 43.4 590.109C43.4 592.595 45.4147 594.609 47.9 594.609Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.23 527.908C25.7153 527.908 27.73 525.893 27.73 523.408C27.73 520.923 25.7153 518.908 23.23 518.908C20.7447 518.908 18.73 520.923 18.73 523.408C18.73 525.893 20.7447 527.908 23.23 527.908Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6 464.189C30.0853 464.189 32.1 462.175 32.1 459.689C32.1 457.204 30.0853 455.189 27.6 455.189C25.1147 455.189 23.1 457.204 23.1 459.689C23.1 462.175 25.1147 464.189 27.6 464.189Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.64 415.568C73.1253 415.568 75.14 413.554 75.14 411.068C75.14 408.583 73.1253 406.568 70.64 406.568C68.1547 406.568 66.14 408.583 66.14 411.068C66.14 413.554 68.1547 415.568 70.64 415.568Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.49 457.43C145.975 457.43 147.99 455.415 147.99 452.93C147.99 450.444 145.975 448.43 143.49 448.43C141.005 448.43 138.99 450.444 138.99 452.93C138.99 455.415 141.005 457.43 143.49 457.43Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter57_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.92 445.748C125.405 445.748 127.42 443.733 127.42 441.248C127.42 438.763 125.405 436.748 122.92 436.748C120.435 436.748 118.42 438.763 118.42 441.248C118.42 443.733 120.435 445.748 122.92 445.748Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.35 356.229C113.835 356.229 115.85 354.214 115.85 351.729C115.85 349.243 113.835 347.229 111.35 347.229C108.865 347.229 106.85 349.243 106.85 351.729C106.85 354.214 108.865 356.229 111.35 356.229Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 363.639C129.345 363.639 131.36 361.624 131.36 359.139C131.36 356.653 129.345 354.639 126.86 354.639C124.375 354.639 122.36 356.653 122.36 359.139C122.36 361.624 124.375 363.639 126.86 363.639Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.91 345.129C130.395 345.129 132.41 343.114 132.41 340.629C132.41 338.144 130.395 336.129 127.91 336.129C125.425 336.129 123.41 338.144 123.41 340.629C123.41 343.114 125.425 345.129 127.91 345.129Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.27 366.119C208.755 366.119 210.77 364.104 210.77 361.619C210.77 359.134 208.755 357.119 206.27 357.119C203.785 357.119 201.77 359.134 201.77 361.619C201.77 364.104 203.785 366.119 206.27 366.119Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.2 282.77C187.685 282.77 189.7 280.755 189.7 278.27C189.7 275.784 187.685 273.77 185.2 273.77C182.715 273.77 180.7 275.784 180.7 278.27C180.7 280.755 182.715 282.77 185.2 282.77Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.73 316.52C160.215 316.52 162.23 314.505 162.23 312.02C162.23 309.534 160.215 307.52 157.73 307.52C155.245 307.52 153.23 309.534 153.23 312.02C153.23 314.505 155.245 316.52 157.73 316.52Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.04 303.039C224.525 303.039 226.54 301.024 226.54 298.539C226.54 296.054 224.525 294.039 222.04 294.039C219.555 294.039 217.54 296.054 217.54 298.539C217.54 301.024 219.555 303.039 222.04 303.039Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.97 203.369C279.455 203.369 281.47 201.354 281.47 198.869C281.47 196.384 279.455 194.369 276.97 194.369C274.485 194.369 272.47 196.384 272.47 198.869C272.47 201.354 274.485 203.369 276.97 203.369Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.31 177.939C315.795 177.939 317.81 175.925 317.81 173.439C317.81 170.954 315.795 168.939 313.31 168.939C310.825 168.939 308.81 170.954 308.81 173.439C308.81 175.925 310.825 177.939 313.31 177.939Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.92 184.219C335.405 184.219 337.42 182.204 337.42 179.719C337.42 177.233 335.405 175.219 332.92 175.219C330.435 175.219 328.42 177.233 328.42 179.719C328.42 182.204 330.435 184.219 332.92 184.219Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.13 137.209C350.615 137.209 352.63 135.194 352.63 132.709C352.63 130.224 350.615 128.209 348.13 128.209C345.645 128.209 343.63 130.224 343.63 132.709C343.63 135.194 345.645 137.209 348.13 137.209Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.83 213.02C357.315 213.02 359.33 211.005 359.33 208.52C359.33 206.034 357.315 204.02 354.83 204.02C352.345 204.02 350.33 206.034 350.33 208.52C350.33 211.005 352.345 213.02 354.83 213.02Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.32 138.398C552.805 138.398 554.82 136.384 554.82 133.898C554.82 131.413 552.805 129.398 550.32 129.398C547.835 129.398 545.82 131.413 545.82 133.898C545.82 136.384 547.835 138.398 550.32 138.398Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter71_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.89 175.619C528.375 175.619 530.39 173.604 530.39 171.119C530.39 168.634 528.375 166.619 525.89 166.619C523.405 166.619 521.39 168.634 521.39 171.119C521.39 173.604 523.405 175.619 525.89 175.619Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter72_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.59 220.068C501.075 220.068 503.09 218.054 503.09 215.568C503.09 213.083 501.075 211.068 498.59 211.068C496.105 211.068 494.09 213.083 494.09 215.568C494.09 218.054 496.105 220.068 498.59 220.068Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter73_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.12 175.479C486.605 175.479 488.62 173.464 488.62 170.979C488.62 168.493 486.605 166.479 484.12 166.479C481.635 166.479 479.62 168.493 479.62 170.979C479.62 173.464 481.635 175.479 484.12 175.479Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter74_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.56 135.629C444.045 135.629 446.06 133.614 446.06 131.129C446.06 128.644 444.045 126.629 441.56 126.629C439.075 126.629 437.06 128.644 437.06 131.129C437.06 133.614 439.075 135.629 441.56 135.629Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter75_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.25 221.818C447.735 221.818 449.75 219.804 449.75 217.318C449.75 214.833 447.735 212.818 445.25 212.818C442.765 212.818 440.75 214.833 440.75 217.318C440.75 219.804 442.765 221.818 445.25 221.818Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter76_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.97 217.889C636.455 217.889 638.47 215.874 638.47 213.389C638.47 210.903 636.455 208.889 633.97 208.889C631.485 208.889 629.47 210.903 629.47 213.389C629.47 215.874 631.485 217.889 633.97 217.889Z",
    fill: "#8FFFFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter77_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.73 201.719C619.215 201.719 621.23 199.704 621.23 197.219C621.23 194.733 619.215 192.719 616.73 192.719C614.245 192.719 612.23 194.733 612.23 197.219C612.23 199.704 614.245 201.719 616.73 201.719Z",
    fill: "#8FFFFC"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter78_d_3572_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.85 592.539C832.335 592.539 834.35 590.524 834.35 588.039C834.35 585.554 832.335 583.539 829.85 583.539C827.365 583.539 825.35 585.554 825.35 588.039C825.35 590.524 827.365 592.539 829.85 592.539Z",
    fill: "#8FFFFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3572_5",
    x: 0,
    y: 0,
    width: 878.28,
    height: 1006.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.952941 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3572_5",
    x: 683.78,
    y: 616.889,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3572_5",
    x: 772.56,
    y: 643.928,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3572_5",
    x: 775.63,
    y: 630.619,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3572_5",
    x: 739.8,
    y: 565.658,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3572_5",
    x: 727.31,
    y: 543.26,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3572_5",
    x: 844.68,
    y: 529.289,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3572_5",
    x: 845.95,
    y: 466.508,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_3572_5",
    x: 805.1,
    y: 407.758,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_3572_5",
    x: 812.52,
    y: 497.879,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_3572_5",
    x: 774.38,
    y: 460.258,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_3572_5",
    x: 692.89,
    y: 473.959,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_3572_5",
    x: 780.35,
    y: 383.539,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_3572_5",
    x: 708.6,
    y: 395.209,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_3572_5",
    x: 747,
    y: 341.109,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_3572_5",
    x: 735.96,
    y: 330.229,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_3572_5",
    x: 708.61,
    y: 296.379,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_3572_5",
    x: 676.97,
    y: 267.168,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_3572_5",
    x: 384.17,
    y: 74.6797,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_3572_5",
    x: 432.95,
    y: 12.7188,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_3572_5",
    x: 487.76,
    y: 77.4082,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_3572_5",
    x: 375.5,
    y: 971.379,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_3572_5",
    x: 424,
    y: 971.549,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_3572_5",
    x: 529.33,
    y: 959.129,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_3572_5",
    x: 551.21,
    y: 966.299,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_3572_5",
    x: 469.73,
    y: 972.439,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_3572_5",
    x: 521.04,
    y: 876.369,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_3572_5",
    x: 309.84,
    y: 967.979,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_3572_5",
    x: 332.08,
    y: 969.398,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_3572_5",
    x: 446.11,
    y: 903.309,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_3572_5",
    x: 418.21,
    y: 886.75,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_3572_5",
    x: 518.94,
    y: 796.09,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_3572_5",
    x: 478.08,
    y: 800.02,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_3572_5",
    x: 469.97,
    y: 775.59,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_3572_5",
    x: 328.59,
    y: 834.1,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_3572_5",
    x: 397.48,
    y: 765.58,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_3572_5",
    x: 413.45,
    y: 729.27,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_3572_5",
    x: 450.49,
    y: 713.709,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_3572_5",
    x: 507.11,
    y: 700.77,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_3572_5",
    x: 187.96,
    y: 683.959,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_3572_5",
    x: 169.28,
    y: 674.619,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_3572_5",
    x: 114.7,
    y: 658.01,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_3572_5",
    x: 101.09,
    y: 657.689,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_3572_5",
    x: 81.47,
    y: 652.469,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_d_3572_5",
    x: 131.23,
    y: 625.93,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_d_3572_5",
    x: 103.72,
    y: 597.77,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_d_3572_5",
    x: 185.84,
    y: 600.459,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_d_3572_5",
    x: 200.72,
    y: 533.969,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_d_3572_5",
    x: 180.87,
    y: 524.709,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_d_3572_5",
    x: 211.47,
    y: 487,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_d_3572_5",
    x: 202.04,
    y: 481.869,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_d_3572_5",
    x: 109.5,
    y: 491.77,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_d_3572_5",
    x: 37.4,
    y: 579.609,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_d_3572_5",
    x: 12.73,
    y: 512.908,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_d_3572_5",
    x: 17.1,
    y: 449.189,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_d_3572_5",
    x: 60.14,
    y: 400.568,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_d_3572_5",
    x: 132.99,
    y: 442.43,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_d_3572_5",
    x: 112.42,
    y: 430.748,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_d_3572_5",
    x: 100.85,
    y: 341.229,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_d_3572_5",
    x: 116.36,
    y: 348.639,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_d_3572_5",
    x: 117.41,
    y: 330.129,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_d_3572_5",
    x: 195.77,
    y: 351.119,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_d_3572_5",
    x: 174.7,
    y: 267.77,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_d_3572_5",
    x: 147.23,
    y: 301.52,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_d_3572_5",
    x: 211.54,
    y: 288.039,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_d_3572_5",
    x: 266.47,
    y: 188.369,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_d_3572_5",
    x: 302.81,
    y: 162.939,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_d_3572_5",
    x: 322.42,
    y: 169.219,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter68_d_3572_5",
    x: 337.63,
    y: 122.209,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter69_d_3572_5",
    x: 344.33,
    y: 198.02,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter70_d_3572_5",
    x: 539.82,
    y: 123.398,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter71_d_3572_5",
    x: 515.39,
    y: 160.619,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter72_d_3572_5",
    x: 488.09,
    y: 205.068,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter73_d_3572_5",
    x: 473.62,
    y: 160.479,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter74_d_3572_5",
    x: 431.06,
    y: 120.629,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter75_d_3572_5",
    x: 434.75,
    y: 206.818,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter76_d_3572_5",
    x: 623.47,
    y: 202.889,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter77_d_3572_5",
    x: 606.23,
    y: 186.719,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter78_d_3572_5",
    x: 819.35,
    y: 577.539,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.858824 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3572_5",
    x1: 678.116,
    y1: 145.488,
    x2: 472.274,
    y2: 590.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3572_5",
    x1: 1073.3,
    y1: 819.109,
    x2: 281.498,
    y2: 473.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3572_5",
    x1: 319.673,
    y1: 618.866,
    x2: 297.017,
    y2: 245.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3572_5",
    x1: 666.168,
    y1: 726.519,
    x2: 5.6921,
    y2: 102.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3572_5",
    x1: 165.049,
    y1: 168.607,
    x2: 244.7,
    y2: 990.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3572_5",
    x1: 278.198,
    y1: 1088.79,
    x2: 754.134,
    y2: 521.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3572_5",
    x1: 701.588,
    y1: 136.689,
    x2: 163.999,
    y2: 495.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3572_5",
    x1: 655.209,
    y1: 717.028,
    x2: 652.179,
    y2: -23.7654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3572_5",
    x1: 855.859,
    y1: 751.41,
    x2: 703.759,
    y2: -53.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3572_5",
    x1: 601.287,
    y1: 1004.57,
    x2: 353.318,
    y2: 826.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3572_5",
    x1: 265.421,
    y1: 924.286,
    x2: 902.67,
    y2: 573.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3572_5",
    x1: 415.662,
    y1: 1034.45,
    x2: 578.579,
    y2: 670.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3572_5",
    x1: 359.028,
    y1: 1034.2,
    x2: 571.049,
    y2: 710.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3572_5",
    x1: 566.138,
    y1: 775.749,
    x2: 324.649,
    y2: 962.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3572_5",
    x1: -331.162,
    y1: 1518.02,
    x2: -872.776,
    y2: 64.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3572_5",
    x1: -23.3132,
    y1: 690.671,
    x2: 603.153,
    y2: 209.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3572_5",
    x1: -14.7482,
    y1: 299.813,
    x2: 592.072,
    y2: 859.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3572_5",
    x1: 504.893,
    y1: 1108.84,
    x2: 921.558,
    y2: 410.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3572_5",
    x1: 1101.9,
    y1: 249.475,
    x2: 310.099,
    y2: 594.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3572_5",
    x1: 953.635,
    y1: 183.533,
    x2: 373.147,
    y2: 714.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3572_5",
    x1: 286.958,
    y1: -20.7925,
    x2: 484.615,
    y2: 643.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3572_5",
    x1: 813.438,
    y1: 205.94,
    x2: 316.239,
    y2: 815.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3572_5",
    x1: 1051.24,
    y1: -71.4035,
    x2: 169.587,
    y2: 351.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3572_5",
    x1: 704.45,
    y1: 72.6774,
    x2: 73.1101,
    y2: 542.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3572_5",
    x1: 376.311,
    y1: 908.739,
    x2: 1002.78,
    y2: 427.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3572_5",
    x1: 62.4887,
    y1: 792.081,
    x2: 619.453,
    y2: 187.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3572_5",
    x1: 429.732,
    y1: -200.374,
    x2: 433.203,
    y2: 991.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3572_5",
    x1: 666.51,
    y1: 1112.82,
    x2: 388.45,
    y2: 368.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3572_5",
    x1: 56.3147,
    y1: 387.711,
    x2: 514.29,
    y2: 355.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3572_5",
    x1: 441.55,
    y1: 928.911,
    x2: -350.251,
    y2: 583.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3572_5",
    x1: 263.784,
    y1: 331.632,
    x2: 250.856,
    y2: 773.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3572_5",
    x1: 86.5912,
    y1: 1003.55,
    x2: -113.349,
    y2: 242.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3572_5",
    x1: 675.12,
    y1: 758.218,
    x2: 13.9869,
    y2: 713.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3572_5",
    x1: -37.6725,
    y1: 124.218,
    x2: 338.468,
    y2: 901.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3572_5",
    x1: 382.16,
    y1: -126.903,
    x2: 106.574,
    y2: 901.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3572_5",
    x1: 20.302,
    y1: 72.344,
    x2: 668.647,
    y2: 546.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3572_5",
    x1: -132.43,
    y1: 775.33,
    x2: 790.788,
    y2: 614.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3572_5",
    x1: 448.314,
    y1: 98.4614,
    x2: 256.501,
    y2: 940.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3572_5",
    x1: 213.537,
    y1: 59.4264,
    x2: 291.398,
    y2: 842.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3572_5",
    x1: 331.486,
    y1: -20.3598,
    x2: 164.394,
    y2: 748.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88D3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#84D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076892"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpadeVectors);
export default __webpack_public_path__ + "static/media/spade-vectors.6edf4eeb20d9aa6342b6b774e1ba6e30.svg";
export { ForwardRef as ReactComponent };